export const LOCAL_FILTER_FIELDS = [
    {
        label: "Code",
        type: "text",
        name: "customerCode",
    },
    {
        label: "Name",
        type: "text",
        name: "customerName",
    },
    {
        label: "Tin no",
        type: "text",
        name: "customerTin",
    },
    {
        label: "Phone number",
        type: "text",
        name: "phoneNumber",
    },
    {
        label: "Email",
        type: "text",
        name: "email",
    }
]